import React, { useState } from 'react';
import WaitingListService from '../../services/WaitingListService.js';
import { connect } from 'react-redux';

function WaitingListApply(props) {
    const getInitialState = () => {
        return {
            waitingListApplication: {
                entry_date: new Date(),
                waiting_list_type_id: 3,
                note: '',
                person: {
                    firstname: '',
                    lastname: '',
                    address: '',
                    postcode: '',
                    suburb: '',
                    phone: '',
                    work: '',
                    email: ''
                }
            },
            referer: {
                firstname: '',
                lastname: '',
                address: '',
                postcode: '',
                suburb: '',
                phone: '',
                work: '',
                email: ''
            },
            liveHere: false,
            haveReference: false,
            saved: false,
            error: null
        }
    };

    const [waitingListApplication, setWaitingListApplication] = useState(getInitialState().waitingListApplication);
    const [referer, setReferer] = useState(getInitialState().referer);
    const [liveHere, setLiveHere] = useState(false);
    const [haveReference, setHaveReference] = useState(false);
    const [saved, setSaved] = useState(false);
    const [error, setError] = useState(null);

    const applyClick = (e) => {
        e.preventDefault();

        if (!waitingListApplication.person.firstname || !waitingListApplication.person.lastname) {
            setError("Fornavn og efternavn er obligatoriske");
        }
        else if (!waitingListApplication.person.address || !waitingListApplication.person.suburb || !waitingListApplication.person.postcode) {
            setError("Adresse felterne er obligatoriske");
        }
        else if (!waitingListApplication.person.email || !waitingListApplication.person.phone) {
            setError("Email og telefon felterne er obligatoriske");
        }
        else if (haveReference && (!referer.firstname || !referer.lastname)) {
            setError("Reference fornavn og efternavn er obligatoriske");
        }
        else if (haveReference && (!referer.address || !referer.postcode || !referer.suburb)) {
            setError("Reference adresse felterne er obligatoriske");
        }
        else if (haveReference && (!referer.email || !referer.phone)) {
            setError("Reference e-mail og telefon felterne er obligatoriske");
        }
        else {
            let requestData;
            if (liveHere) {
                const updatedApplication = { ...waitingListApplication, waiting_list_type_id: 1 };
                setWaitingListApplication(updatedApplication);
                requestData = {
                    waitingList: updatedApplication
                };
            }

            if (haveReference) {
                const updatedApplication = { ...waitingListApplication, waiting_list_type_id: 2 };
                setWaitingListApplication(updatedApplication);
                requestData = {
                    waitingList: updatedApplication,
                    referer: referer
                };
            }

            if (!liveHere && !haveReference) {
                const updatedApplication = { ...waitingListApplication, waiting_list_type_id: 3 };
                setWaitingListApplication(updatedApplication);
                requestData = {
                    waitingList: updatedApplication
                };
            }

            WaitingListService.createApplication(requestData)
                .then((response) => {
                    // TODO: server will start sending back payment link and will then require this app to send customers to payment gateway, if succesfull redirects to successpage if not redirect to failure page.

                    console.log(response);
                    
                    window.location.href = response; 

                    // setSaved(true);
                }).catch(function (err) {
                    alert("Der opstod en fejl");
                    console.log("Error saving", err);
                    setError(err);
                });
        }
    };
    
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-8 offset-md-2 login center-block">
                    <div className="standardBackground">
                        <div id="waitingListApply">
                            <h2>Ansøg om venteliste</h2>
                            <p>Obs, læs venligst reglerne for ventelisterne inden du ansøger. <a href="https://www.vg.dk/lejligheder/#venteliste-section">Se reglerne her.</a></p>
                            <div className="alert alert-warning" role="alert">
                                <span className="info-icon" aria-hidden="true">&#9432;</span>
                                Betalingssystemet er nede, og man kan derfor ikke skrive sig på ventelisten pt.
                            </div>
                            
                            {saved && <div>Ansøgning sendt.</div>}
                            {error && <div className="error">{error}</div>}
                            {!saved &&
                                    <form>
                                    <div className="form-group">
                                        <label  >Fornavn</label>
                                        <input type="text" value={waitingListApplication.person.firstname} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, firstname: event.target.value } })} className=" form-control" id="firstname" required />
                                    </div>
                                    <div className="form-group">
                                        <label  >Efternavn</label>
                                        <input type="text" value={waitingListApplication.person.lastname} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, lastname: event.target.value } })} className=" form-control" id="lastname" required />
                                    </div>
                                    <div className="form-group">
                                        <label  >Adresse</label>
                                        <input type="text" value={waitingListApplication.person.address} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, address: event.target.value } })} className=" form-control" id="address" required />
                                    </div>
                                    <div className="form-group">
                                        <label  >By</label>
                                        <input type="text" value={waitingListApplication.person.suburb} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, suburb: event.target.value } })} className=" form-control" id="suburb" required />
                                    </div>
                                    <div className="form-group">
                                        <label  >Postnummer</label>
                                        <input type="text" value={waitingListApplication.person.postcode} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, postcode: event.target.value } })} className="form-control" id="postcode" required />
                                    </div>

                                    <div className="form-group">
                                        <label  >E-mail</label>
                                        <input type="text" value={waitingListApplication.person.email} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, email: event.target.value } })} className=" form-control" id="email" required />
                                    </div>

                                    <div className="form-group">
                                        <label >Telefon</label>
                                        <input type="text" value={waitingListApplication.person.phone} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, person: { ...waitingListApplication.person, phone: event.target.value } })} className=" form-control" id="phone" required />
                                    </div>

                                    <div className="form-group">
                                        <div>
                                            <label>Noter</label>
                                        </div>
                                        <textarea className="form-control" rows="2" id="comment" value={waitingListApplication.note} onChange={(event) => setWaitingListApplication({ ...waitingListApplication, note: event.target.value })} ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-12 marginLeft1" >Er du nuværende beboer?</label>
                                        <input className="col-md-12" type="checkbox" value={liveHere} onChange={(event) => setLiveHere(event.target.checked)} />
                                    </div>

                                    {!liveHere &&
                                        <div>
                                            <div className="form-group">
                                                <label className="col-md-12 marginLeft1" >Er du blevet henvist af en nuværende beboer?</label>
                                                <input className="col-md-12" type="checkbox" value={haveReference} onChange={(event) => setHaveReference(event.target.checked)} />
                                            </div>
                                            {haveReference &&
                                                    <div>
                                                        <div>
                                                        En andel kan kun have én skrevet op på liste D ad gangen. Hvis man som andelshaver skriver flere op, vil de blive slettet fra listen (D) og deres indbetaling mistes, da vi ikke automatisk kan overføre til liste E.
                                                        </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Intern Ref. Fornavn</label>
                                                        <input type="text" value={referer.firstname} onChange={(event) => setReferer({ ...referer, firstname: event.target.value })} className=" form-control" id="referer_firstname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Intern Ref. Efternavn</label>
                                                        <input type="text" value={referer.lastname} onChange={(event) => setReferer({ ...referer, lastname: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Adresse</label>
                                                        <input type="text" value={referer.address} onChange={(event) => setReferer({ ...referer, address: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Postnummer</label>
                                                        <input type="text" value={referer.postcode} onChange={(event) => setReferer({ ...referer, postcode: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">By</label>
                                                        <input type="text" value={referer.suburb} onChange={(event) => setReferer({ ...referer, suburb: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Ref. Telefon nr.</label>
                                                        <input type="text" value={referer.phone} onChange={(event) => setReferer({ ...referer, phone: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="address">Ref. E-mail</label>
                                                        <input type="text" value={referer.email} onChange={(event) => setReferer({ ...referer, email: event.target.value })} className=" form-control" id="referer_lastname" required />
                                                    </div>
                                                    </div>
                                            }
                                        </div>
                                    }
                                    <div className="form-buttons">
                                        <button type="submit" className="btn btn-primary" onClick={applyClick}>Indsend</button>
                                    </div>
                                </form>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    const { _apartments, _apartment } = state.apartments
    return { _apartments, _apartment };
}

export default connect(mapStateToProps)(WaitingListApply)
